'use strict';

const _ = require('lodash');
const $ = require('jquery');
const rearg = require('./rearg');

const {format: dtFormat} = require('date-fns');
const numeral = require('numeral');
const TS = require("@zerolight/zlthunder-time-utils");

const {CSSList}  = require('./css-list');

function noop() {
}

function identity(v) {
	return v;
}

function isContainer($container) {
	return $container instanceof $ || _.isElement($container) || _.isString($container);
}

function cssClasses() {
	let c = new CSSList();
	for (let a of arguments) {
		c.add(a);
	}
	return c.css;
}

let DATE_FORMAT = 'yyyy-MM-dd';
let DATE_TIME_FORMAT = 'yyyy-MM-dd h:mm a';

function formatDate(value, format) {
	value = TS.validate(value);
	if (!value) {
		return '';
	}

	if (format) {
		return dtFormat(value, format);
	}

	let hours = value.getHours();
	let minutes = value.getMinutes();
	if (hours || minutes) {
		format = DATE_TIME_FORMAT;
	} else {
		format = DATE_FORMAT;
	}
	return dtFormat(value, format);
}

function formatNumber(value, format) {
	if (!value) {
		return 0;
	}
	let n = Number(value);
	if (isNaN(n)) {
		return value;
	}
	return numeral(n).format(format || numeral.defaultFormat);
}

function formatMinutes(value) {
	if (value) {
		value = Math.round(value);
		let m = numeral(Math.floor(value / 60)).format(numeral.defaultFormat);
		let sec = String(value % 60).padStart(2, '0');
		return `${m}:${sec}`;
	}
	return '';
}

function pretty(value) {
	return _.words(value).map(_.capitalize).join(' ');
}

function bindHandler(context, handler) {
	return function () {
		return handler.call(context, this, ... arguments);
	}
}

function bindHandlers(context, ... names) {
	for (let name of names) {
		let handler = context[name];
		if (!_.isFunction(handler)) {
			throw new TypeError(`${name} should be a function`);
		}
		context[name] = bindHandler(context, handler);
	}
}

function bindCallback(method, context, ... bargs) {
	return function wrapper(... args) {
		let callback;
		let l = args.length;
		if (l && _.isFunction(args[l - 1])) {
			callback = args[l - 1];
			// args = args.slice(0, -1);
		}
		// If it returns promise...
		let returns = method.call(context, ...bargs, ...args);
		if (returns instanceof Promise) {
			if (callback) {
				// If callback is given - handle it and return nothing
				returns
					.then(
						function (result) {
							callback(null, result);
						},
						function (reason) {
							callback(reason);
						}
					)
					.catch(function (err) {
						console.error(err);
					});
				return;
			}
		}
		return returns;
	}
}

function bindCallbackAll(obj, ... methods) {
	for (let key of methods) {
		let method = obj[key];
		if (_.isFunction(method)) {
			obj[key] = bindCallback(method, obj);
		}
	}
}

function thenCallback(promise, callback) {
	if (callback) {
		promise
			.then(
				function (response) {
					callback(null, response);
				},
				function (err) {
					callback(err);
				}
			)
			.catch(function (err) {
				console.error(err);
				throw err;
			});
	} else {
		return promise;
	}
}

const DOES_IT_LOOK_LIKE_REGEXP = /^\/(.+)\/([im]+)?$/;
function testString(test, string) {
	let m;
	if (test instanceof RegExp) {
		return test.test(string);
	}
	if ((m = DOES_IT_LOOK_LIKE_REGEXP.test(test))) {
		test = new RegExp(m[1], m[2]);
		return test.test(string);
	}
	return test === string;
}

let _uniqueIdCounter = 0;

function uniqueId() {
	_uniqueIdCounter = (_uniqueIdCounter + 1) & 0xff;
	return (
		_uniqueIdCounter.toString(16).padStart(2, '0') +
		((Math.random() * 0xffff) & 0xffff).toString(16).padStart(4, '0')
	);
}

function wait(to, resolveWith) {
	return new Promise((res) => {
		setTimeout(res, to, resolveWith);
	});
}

function getIn(obj, path, def = null) {
	if (!obj) {
		return def;
	}
	if (!Array.isArray(path)) {
		path = [path];
	}
	let c = obj;
	for (let i = 0; i < path.length; i++) {
		let k = path[i];
		let has;
		try {
			has = Object.prototype.hasOwnProperty.call(c, k);
		} catch (err) {
			return def;
		}
		if (has) {
			c = c[k];
		} else {
			return def;
		}
	}
	return c;
}

function getFieldName(field) {
	return Array.isArray(field) ? field[0] : field;
}

function getFieldTitle(field) {
	let title;
	if (Array.isArray(field)) {
		title = field[1];
	}
	return title || pretty(getFieldName(field));
}


module.exports = {
	noop, identity,
	rearg, cssClasses, isContainer, formatDate, formatNumber, formatMinutes, pretty,
	bindHandler, bindHandlers, bindCallback, bindCallbackAll, thenCallback, testString,
	uniqueId, wait, getIn,
	getFieldName, getFieldTitle
};